<template>
    <div class="BoxBox">
        <div class="bannerBox">
            <div class="contentBox">
                <div class="content">
                    <div class="title">2021版权家优惠大作战</div>
                    <div class="tip">全面保护版权，最低只需126.66元</div>
                    <div class="activeityTime">
                        <div class="text">活动剩余</div>
                        <div class="number">{{day}}</div>
                        <div class="mt">天</div>
                        <div class="number">{{hou}}</div>
                        <div class="mt">时</div>
                        <div class="number">{{min}}</div>
                        <div class="mt">分</div>
                        <div class="number">{{sec}}</div>
                        <div class="mt">秒</div>
                    </div>
                </div>
                <img class="logose" src="./images/2021.png" alt="版权登记">
            </div>
        </div>
        <div class="springFestivalMain">
            <div class="springFestivalMainBox">
                <div class="mainTitle">
                    <!-- <div class="box">
                        <div class="text">会员限时优惠6.6折<span class="line"></span></div>
                    </div> -->
                    <div class="newBox">
                        <div class="text">会</div>
                        <div class="text">员</div>
                        <div class="text">限</div>
                        <div class="text">时</div>
                        <div class="text">优</div>
                        <div class="text">惠</div>
                        <div class="text">6.6</div>
                        <div class="text">折</div>
                    </div>
                    <div class="ytime">限时优惠活动时间：2021.2.5-2021.2.28</div>
                </div>
                <div class="vipCard">
                    <div class="item" :class="index == 0?'itemT':index == 1?'itemY':index == 2?'itemJ':''" v-for="(item,index) in springFestivalData.result" :key="index">
                        <div class="title" :class="index == 0?'titleBg1':index == 1?'titleBg2':index == 2?'titleBg3':''">
                            <img class="tt" src="./images/tt.png" alt="版权登记" v-if="index == 0">
                            <img class="tt" src="./images/yy.png" alt="版权登记" v-if="index == 1">
                            <img class="tt" src="./images/jj.png" alt="版权登记" v-if="index == 2">
                            <div class="info">
                                <div class="name">{{item.title}}</div>
                                <div class="msg">会员有效期：{{item.period}}{{item.periodType == 'year'?'年':'月'}}</div>
                            </div>
                        </div>
                        <div class="moneyInfo">
                            <div class="money">
                                <span class="m">¥</span>
                                <span class="num">{{item.value}}</span>
                                <span class="m">/{{item.periodType == 'year'?'年':'月'}}</span>
                                <div class="remarks">{{item.registerVipRights.remarks}}</div>
                            </div>
                            <div class="yuan">原价：{{item.flagValue}}元/年</div>
                        </div>
                        <div class="titleLine">
                            <img class="line" src="./images/ll2.png" alt="版权登记">
                            <span class="t">会员权益</span>
                            <img class="line" src="./images/rr2.png" alt="版权登记">
                        </div>
                        <div class="quanInfo">
                            <div class="itemInfo">
                                <div class="lable">存证</div>
                                <div class="num">{{item.registerVipRights.evidenceArchiveNum}}次</div>
                            </div>
                            <div class="itemInfo">
                                <div class="lable">登记</div>
                                <div class="num">{{item.registerVipRights.copyrightRegisterNum }}次</div>
                            </div>
                            <div class="itemInfo">
                                <div class="lable">图片监听</div>
                                <div class="num">{{item.registerVipRights.imageMonitorNum }}次</div>
                            </div>
                            <div class="itemInfo">
                                <div class="lable">音乐监听</div>
                                <div class="num">{{item.registerVipRights.musicMonitorNum }}次</div>
                            </div>
                            <div class="itemInfo">
                                <div class="lable">文本监听</div>
                                <div class="num">{{item.registerVipRights.textMonitorNum }}次</div>
                            </div>
                            <div class="itemInfo">
                                <div class="lable">下载监听报告</div>
                                <div class="num">{{item.registerVipRights.imageMonitorNum + item.registerVipRights.musicMonitorNum + item.registerVipRights.textMonitorNum }}次</div>
                            </div>
                            <div class="itemInfo">
                                <div class="lable">取证</div>
                                <div class="num">{{item.registerVipRights.forensicsNum }}次</div>
                            </div>
                            <div class="itemInfo">
                                <div class="lable">电子公证</div>
                                <div class="num">{{item.registerVipRights.notarizationNum }}次</div>
                            </div>
                        </div>
                        <div class="infoBtn" @click="goSy(item)">立即开通</div>
                    </div>
                </div>
                <div class="moreTip">
                    <div class="t">更多优惠，请联系：宋温暖 17611602603</div>
                </div>
                <div class="mainTitle" style="margin-top:30px">
                    <!-- <div class="box">
                        <div class="text">关注有礼<span class="line"></span></div>
                    </div> -->
                    <div class="newBox">
                        <div class="text">关</div>
                        <div class="text">注</div>
                        <div class="text">有</div>
                        <div class="text">礼</div>
                    </div>
                    <div class="ytime">关注版权家服务号即可领取丰厚福利</div>
                </div>
                <div class="blockCard">
                    <div class="left">
                        <img class="bg" src="./images/cardB.png" alt="版权登记">
                    </div>
                    <div class="right">
                        <div class="title">关注版权家服务号，赠送100次存证权益</div>
                        <div class="textUl">
                            <div class="item">1、在微信中搜索“版权家服务”或扫描左侧“版权家服务号”二维码</div>
                            <div class="item">2、关注服务号后在对话框中输入关键词 <span class="span">“关注有礼+您的注册手机”，</span> 回复关键词后，将会由工作人员联系您核实赠送福利。</div>
                        </div>
                    </div>
                </div>
                <div class="mainTitle">
                    <!-- <div class="box">
                        <div class="text">活动说明<span class="line"></span></div>
                    </div> -->
                    <div class="newBox">
                        <div class="text">活</div>
                        <div class="text">动</div>
                        <div class="text">说</div>
                        <div class="text">明</div>
                    </div>
                </div>
                <div class="blockCard2">
                    <div class="right">
                        <div class="textUl">
                            <div class="item">① 活动时间：2021.2.5-2021.2.28；</div>
                            <div class="item">② 会员包福利所有用户均可参与购买；</div>
                            <div class="item">
                                <div>③ 关注有礼，需关注指定微信服务号后，且成功回复活动指定关键词后，</div>
                                <div><span style=" opacity: 0;">⑤ </span>将于春节假期结束后5个工作日加微信核实派发关注权益；</div>
                            </div>
                            <div class="item">④ 该优惠活动不与其他线上优惠政策同享；</div>
                            <div class="item">
                                <div>⑤ 参与活动时如有疑问请拨打免费客服热线:17316071136/37；</div>
                                <div><span style=" opacity: 0;">⑤ </span>最终解释权归北京版全家科技发展有限公司所有</div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="left">
                        <img class="bg" src="./images/cardB2.png" alt="版权登记">
                    </div>
                </div>
            </div>
        </div>
        <div class="loginSpringFestival" v-if="closeLogInShow">
            <div class="loginForm">
                <div class="titleClose">
                    <img style="cursor:pointer;" class="closeClass"  @click="closeLogIn" src="./images/close.png" alt='版权登记'/>
                </div>
                <img class="logo" src="./images/logo.png" alt='版权登记'/>
                <img class="titleTip" src="./images/titleTip.png" alt='版权登记'/>
                <div class="htime">活动时间：2021.02.05-2021.02.28</div>
                <Form ref="mobileUpdateForm" :model="form"  :rules="rules"  class="formData" >
                    <FormItem  prop="username" class="loginInput">
                        <div class="item">
                            <div class="lable">
                                <img class="phone" src="./images/phone.png" alt="版权登记">
                                <div>手机号：</div>
                            </div>
                            <Input class="input" v-model="form.username" placeholder="请输入手机号领取福利" autocomplete="off" />
                        </div>
                    </FormItem> 
                     <FormItem  prop="username" class="loginInput">
                         <div class="msgTip">*信息保护中，请放心填写</div>
                    </FormItem> 
                    <FormItem  prop="verifyCode" class="loginInput">
                        <div class="item">
                            <div class="lable">
                                <img class="phone" src="./images/code.png" alt="版权登记">
                                <div>验证码：</div>
                            </div>
                            <Input class="input" type="text" v-model="form.verifyCode" placeholder="请输入验证码" autocomplete="off"/>
                            <input  v-if="verifyCode_time >=0 && verifyCode_time <=60"  v-model="verifyCode_time" type="button"  class="loginVertial" />
                            <input  v-else type="button" @click.prevent="SendNumCode(7)" class="loginVertial"  v-model="verifyCode_time" >
                        </div>
                    </FormItem>
                    <FormItem class="loginInput">
                        <div class="fuxy">
                            <img @click="checkchdata()" :src="checkboxmn=='Y'?ye:noye" alt='版权登记'/>
                            <p>阅读并同意</p>
                            <a @click="lawLink">《注册协议及隐私协议》</a>
                        </div>
                    </FormItem>
                    <FormItem>
                        <div class="infoBtnPay" @click="onPayMoney()">去支付</div>
                    </FormItem>
                </Form> 
            </div>
        </div>
        <myPay v-if="showModal01" :subBizType="subBizType" :payMoney="payMoney" @fatherModal="fatherModal" mywidth='766' myHeight="425" myTitleheight="50"/>
        <!-- <myCzpay @fatherModal="fatherModal" mywidth='838' myheight="585" myTitleheight="50" v-if="showModal02"/> -->
    </div>
</template>

<script>
    let currentDate, tempDate, ms = null;
    
    import {userInfo,_findIndexPageShowNewNew} from '@/api/index.js';
    import {_findIndexPageShowActivity,sendSmsCode,propertyRightLogon} from '@/api/activity.js'
    import {_sysGetTime} from "@/api/staticPage.js";
    import Cookies from "js-cookie";
    import EventBus from "@/libs/eventBus"
    import myPay from './../vip/lawcomponent/mypay.vue';
    import myCzpay from './../vip/lawcomponent/myczpay.vue';
    import util from "@/libs/util.js";
    export default {
        metaInfo: {
            title: '版权登记|版权保护-版权服务专家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权登记,版权保护,版权登记查询,版权保护中心,版权保护服务,版权登记服务,版权家'
            },{
                name: 'Description',
                content: '版权家是专业提供版权登记查询，版权保护申请；我们作为版权保护服务专家，为版权人提供极致的版权登记咨询、版权交易、版权监测、版权维权等服务体验。'
            }]
        },
        name:'springFestival',
        components:{
            myPay,myCzpay
        },
        data(){
            return {
                springFestivalData: {},
                curStartTime: '2019-07-31 08:00:00',
                day: '00',
                hou: '00',
                min: '00',
                sec: '00',
                ssec: '00',
                endTime: 1614527999000,
                _interval: null,
                form: {
                    username: "",
                    verifyCode: '',
                },
                rules: {
                    username: [
                        {
                            required: true,
                            message: "手机号不能为空",
                            trigger: "blur"
                        }
                    ],
                    verifyCode: [
                        {
                            required: true,
                            message: "验证码不能为空",
                            trigger: "blur"
                        }
                    ],
                },
                countdown: '',
                verifyCode_time: '获取验证码',
                checkboxmn: 'Y',
                ye: require('@/assets/images/new_lo_r.png'),
                noye: require('@/assets/images/new_lo_hu.png'),
                closeLogInShow: false,
                showModal01: !1,
                showModal02: !1,
                saveLogin: false,
                subBizType: '',
                payMoney: '0',
                payItem: {}
            }
        },
        mounted(){
            this.getWord();
            this._findIndexPageShowActivity()
            if (this._interval) {
                clearInterval(this._interval)
            }
            this.getAndSetTime();
        },
        beforeCreate() {
            if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
                let source = util.getQueryString('laiyuan');
                if (source && source != '') {
                    window.location.href = `https://m.bqj.cn/pages/activity/huodong/chunjie?laiyuan=${source}`;
                } else {
                    window.location.href = "https://m.bqj.cn/pages/activity/huodong/chunjie";
                }
            }
        },
        created(){
            //未登录
            //this.unloginPopup()
            //已登录        
            let aaa = 0
            EventBus.on('showModalFun',(aaa)=>{
                console.log('登录了jj')
            });


            EventBus.on('logout',(aaa)=>{
                console.log('退出了out')
            })
            EventBus.emit("springFestival", 'springFestival');
        },
        //当离开页面时，清除倒计时
        beforeDestroy() {
            if (this._interval) {
                clearInterval(this._interval)
            }
            localStorage.setItem('springFestival','')
            this.$bus.$off('springFestival')
        },
        methods:{
            fatherModal() {
                let _this = this;
                _this.showModal01 = !1;
                _this.showModal02 = !1;
            },
            //ucenter通信
            callChild(jscode){
                
                // 传参并指定回调执行函数为onBack
                for(let j = 0, len = jscode.length; j < len; j++) {
                    let script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.src = jscode[j] + '&callback=onBack';
                    document.head.appendChild(script);
                }
            },
            onPayMoney() {
                let that = this
                let data = {
                    username: that.form.username,
                    verifyCode: that.form.verifyCode,
                    appKey: 49497644,
                    source: window.location.href
                }
                let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (this.form.username == '') {
                    toast('请输入手机号')
                    return false;
                } else if (!myreg.test(this.form.username)) {
                    toast('手机号格式不正确')
                    return false;
                } else if (that.form.verifyCode == '') {
                    toast('验证码不能为空')
                    return false;
                }  
                if (this.checkboxmn == 'N') {
                    toast('请勾选并同意注册协议及隐私协议')
                    return false;
                }
                // 15801297662
                propertyRightLogon(data).then( res => {
                    console.log(res);
                    if (res.success) {
                        that.setStore("accessToken", res.result);
                        let jscode = res.javascript;
                        that.callChild(jscode);

                        // 获取用户信息
                        userInfo().then(res => {
                            console.log("?????????????????????", res)
                            if (res.code == 200) {
                                // 避免超过大小限制
                                if (that.saveLogin) {
                                    // 保存7天
                                        Cookies.set("userInfo", JSON.stringify(res.result), {
                                        expires: 7
                                    });
                                } else {
                                    Cookies.set("userInfo", JSON.stringify(res.result));
                                }
                                
                                that.setStore("userInfo", res.result);
                                let photo = res.result.photo ? res.result.photo : ''

                                EventBus.emit("childFn", photo);

                                that.$store.commit("setAvatarPath", photo);
                                that.$store.state.app.showPayWay = true
                                
                                // 加载菜单
                                util.initRouter(this);
                                EventBus.emit("showModalFun", 'aaa');
                                console.log("登陆成功拉！")
                                this.closeLogInShow = !this.closeLogInShow
                                that.goSy(that.payItem)
                            }
                        });
                    } else {
                        this.loading = false;
                        this.isDisable = false ;
                        // this.getCaptchaImg();
                        toast(res.message)
                    }
                })
            },
            closeLogIn() {
                this.closeLogInShow = !this.closeLogInShow
            },
            lawLink() {
                window.open('/instrument/2', '_blank')
            },
            checkchdata() {
                this.checkboxmn = this.checkboxmn == 'Y' ? 'N' : 'Y'
            },
            SendNumCode(type) {
                console.log('进入');
                var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                let params;
                let _this = this
                if (this.form.username == '') {
                    toast('请输入手机号')
                    return false;
                } else if (!myreg.test(this.form.username)) {
                    toast('手机号格式不正确')
                    return false;
                } else {
                    console.log('手机号格式正确')
                    params = {
                        mobile: this.form.username,
                        type: type
                    }
                }                
                sendSmsCode(params).then(res => {
                    
                    if (res.code == 200) {
                        toast('发送验证码成功')
                        this.verifyCode_time = 60
                        this.ver_disabled = 'none'
                        const timer = setInterval(() => {
                            if (this.verifyCode_time > 0 && this.verifyCode_time <= 60) {
                                this.verifyCode_time = this.verifyCode_time - 1
                                console.log(this.verifyCode_time);
                            } else {
                                clearInterval(timer);
                                this.verifyCode_time = '获取验证码'
                                this.ver_disabled = 'auto'
                            }
                        }, 1000)
                    }
                })
            },
            goSy(money){
                console.log('-----------------',money)
                let _this = this;
                _this.payItem = money
                localStorage.setItem('springFestival',_this.$route.path)
                userInfo().then(res=>{
                    if (res.code==200) {
                        Cookies.set("userInfo", JSON.stringify(res.result));
                        _this.setStore("userInfo", res.result);
                        let userInfo = res.result ;
                        if(userInfo==''){
                            toast('请登录后再操作')
                            return false;
                        }
                        if (userInfo.vipFlag) {
                            this.showModal01 = !0;
                            this.showModal02 = !0
                        }
                        this.subBizType = money.code

                        this.payMoney = money.value
                    } else {
                         _this.closeLogInShow = !_this.closeLogInShow
                    }
                })
            },
            getAndSetTime() {
                if (!this._interval) {
                    this.getTimeFun();
                    let timer = setInterval(() => {
                        this.setTimeFun()
                    }, 100)
                    this._interval = timer;
                }
            },
            setTimeFun() {
                let that = this;
                if (tempDate == null) {
                    return
                } else {
                    let nowDate = new Date().getTime() + ms;
                    if (nowDate - currentDate > 1000) {
                        this.getTimeFun()
                    } else {
                        currentDate = nowDate;

                        var date = (new Date(that.endTime)) - (currentDate);
                        //new Date当前的时间戳，也可以换成自定义的时间戳
                        if (date > 0) {
                            let time = date / 1000;
                            // 获取时、分、秒,毫秒
                            that.day = parseInt(time / (24 * 60 * 60)) < 10 ? ('0' + parseInt(time / (24 * 60 * 60))) : parseInt(time / (24 * 60 * 60)) + '';
                            that.hou = parseInt((time % (60 * 60 * 24)) / 3600) < 10 ? ('0' + parseInt((time % (60 * 60 * 24)) / 3600)) : parseInt((time % (60 * 60 * 24)) / 3600) + '';
                            that.min = parseInt(((time % (60 * 60 * 24)) % 3600) / 60) < 10 ? ('0' + parseInt(((time % (60 * 60 * 24)) % 3600) / 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) / 60) + '';
                            that.sec = parseInt(((time % (60 * 60 * 24)) % 3600) % 60) < 10 ? ('0' + parseInt(((time % (60 * 60 * 24)) % 3600) % 60)) : parseInt(((time % (60 * 60 * 24)) % 3600) % 60) + '';
                            that.ssec = parseInt(((date % (60 * 60 * 24)) % 3600) / 60) % 10
                        } else {
                            //活动已结束，全部设置为'00'
                            // console.log("aaa")
                            that.day = "00",
                            that.hou = "00",
                            that.min = "00",
                            that.sec = "00";
                            clearInterval(that._interval)
                        }
                    }

                }
            },
            /**************获取国家授时时间**************/
            getTimeFun() {
                /*_sysGetTime().then((res) => {
                    tempDate = res.data ? res.data : new Date().getTime();
                    currentDate = new Date().getTime();
                    ms = tempDate - currentDate;
                    currentDate = currentDate + ms;

                })*/
            },
            _findIndexPageShowActivity() {
                let that = this
                let data = {
                    subBizType: 1601
                }
                _findIndexPageShowActivity(data).then( res => {
                    that.springFestivalData = res
                })
            },
            //截取百度搜索关键字
            queryString(parm,parm2){
                var baiduKeyWords = "";
                let fromUrl = parm2.split("?");
                let fromUrl2=fromUrl[1].split("&");
                let wordsArr = fromUrl2.filter(item=>item.match(parm))
                let wordsArr2 = wordsArr.join("").split("=")
                return baiduKeyWords=wordsArr2[1]                               
            },
            //获取跳转到版权家官网首页的路径
            getWord(){
                if(window.document.referrer){
                    // 获取上级页面
                    let url = document.referrer;
                    // 判断是不是百度的域名
                    if(url.match("www.baidu.com")) {
                        // 第一个参数是百度的get参数wd拼接的关键词
                        let mywords = this.queryString("wd",url);
                        if(mywords != '') console.log(decodeURI(mywords));
                        // 判断是不是百度手机端
                    }else if(url.match("m.baidu.com")){
                        let mywords = this.queryString("word",url);
                        if(mywords != '') console.log(decodeURI(mywords));
                    }else{
                        console.log(url+'不是从百度搜索来的')
                    }
                }else{
                    console.log("没有document.referrer属性")
                }
            },

            //跳转页面方法
            jumpRouter(url){
                window.open(url)
            }
        },
        beforeDestroy(){
            EventBus.off('showModalFun');

            EventBus.off('logout')
        },

    }
</script>

<style scoped lang="less">
    .BoxBox{
        min-width: 1344px;
    }
    .bannerBox{
        background: url(./images/bigbg.png) no-repeat;
        background-size: 100% 100%;
        height: 460px;
        .contentBox{
            display: flex;
            display: -webkit-flex;
            align-items:center;
            justify-content:center;
            height: 460px;
            .content{
                color: #fff;
                .title{
                    font-size: 45px;
                    font-weight: bold;
                    margin-top:25px;
                }
                .tip{
                    font-size: 34px;
                    margin-top:20px;
                }
                .activeityTime{
                    display: flex;
                    align-items: center;
                    margin-top:55px;
                    .text{
                        font-size: 18px;
                    }
                    .number{
                        font-size: 28px;
                        font-weight: bold;
                        width: 40px;
                        margin-right: 9px;
                        margin-left: 9px;
                        line-height: 42px;
                        background: linear-gradient(to bottom, #f9c33b , #f1941f);
                        background-size: 100% 100%;
                        text-align: center;
                        border-radius: 6px;
                    }
                    .mt{
                        font-size: 16px;
                    }
                }
            }
            .logose{
                width: 593px;
                height: 318px;
                margin-left:85px;
            }
        }
    }
    .springFestivalMain{
        background: url('./images/mainbg.jpg') no-repeat;
        background-size: 100% 100%;
        .springFestivalMainBox{
            width: 1344px;
            margin: auto;
            padding: 60px 0;
            .mainTitle{
                .box{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .text{
                        font-size: 26px;
                        position: relative;
                        z-index: 9;
                        font-weight: bold;
                        color: #fff;
                        .line{
                            width: 100%;
                            height: 8px;
                            background: #FFD800;
                            position: absolute;
                            left: 0;
                            bottom: 5px;
                            z-index: -1;
                        }
                    }
                }
                .ytime{
                    font-size: 14px;
                    text-align: center;
                    color: #fff;
                    margin: 12px 0;
                }
            }
            .newBox{
                display: flex;
                align-items: center;
                justify-content: center;
                .text{
                    background: #de292d;
                    color: #FFD800;
                    border: solid 1px #FFD800;
                    font-size: 27px;
                    font-weight: bold;
                    width: 50px;
                    height: 50px;
                    line-height: 50px;
                    text-align: center;
                    border-radius: 100%;
                    margin-left: -5px;
                }
            }
            .vipCard{
                display: flex;
                display: -webkit-flex;
                align-items:center;
                justify-content:center;
                margin-top: 50px;
                .item{
                    width:380px;
                    height:694px;
                    .title{
                        background-size: 100% 100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 12px 0;
                        .tt{
                            width: 57px;
                            height: 72px;
                        }
                        .info{
                            padding: 0 20px;
                            .name{
                                font-size: 18px;
                                font-weight: bold;
                                color: #7A4F2D;
                            }
                            .msg{
                                font-size: 14px;
                                color: #7A4F2D;
                                margin-top: 6px;
                            }
                        }
                    }
                    .moneyInfo{
                        padding: 30px 0;
                        .money{
                            display: flex;
                            color: #E34704;
                            align-items: baseline;
                            justify-content: center;
                            .m{
                            font-size: 14px; 
                            }
                            .num{
                                font-size: 36px;
                                font-weight: bold;
                                padding: 0 4px;
                            }
                            .remarks{
                                background: url(./images/zz.png) no-repeat;
                                font-size: 12px;
                                color: #fff;
                                background-size: 50px 20px;
                                width: 50px;
                                height: 20px;
                                line-height: 20px;
                                text-align: center;
                                padding-left: 10px;
                                margin-left: 10px;
                            }
                        }
                        .yuan{
                            font-size: 14px;
                            text-decoration:  line-through;
                            color: #999999;
                            text-align: center;
                        }
                    }
                    .titleLine{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        .line{
                            width: 92px;
                            height: 6px;
                            display: block;
                        }
                        .t{
                            font-size: 16px;
                            font-weight: bold;
                            color: #333;
                            padding: 0 15px;
                        }
                    }
                    .quanInfo{
                        width: 55%;
                        margin: auto;
                        padding-top: 30px;
                        .itemInfo{
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            font-size: 14px;
                            color: #333;
                            margin-bottom: 15px;
                        }
                    }
                    .infoBtn{
                        font-size: 14px;
                        width: 240px;
                        margin: 30px auto;
                        color: #fff;
                        text-align: center;
                        line-height: 40px;
                        border-radius: 4px;
                        cursor: pointer;
                        background: url(./images/btbg.png) no-repeat;
                        background-size: 100% 100%;
                    }
                }
                .itemT{
                    background: url(./images/t.png) no-repeat;
                    background-size: 100% 100%;
                }
                .itemY{
                    background: url(./images/y.png) no-repeat;
                    background-size: 100% 100%;
                    margin-left:30px;
                    margin-right:30px;
                }
                .itemJ{
                    background: url(./images/j.png) no-repeat;
                    background-size: 100% 100%;
                }
            }
            .moreTip{
                padding: 40px 0;
                display: flex;
                align-items: center;
                justify-content: center;
                .t{
                    font-size: 14px;
                    color: #E02528;
                    text-align: center;
                    padding: 0 20px;
                    line-height: 40px;
                    background: #FFDC83;
                    border-radius: 4px;
                    font-weight: bold;
                }
            }
            .blockCard{
                width: 1190px;
                margin: 60px auto;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: linear-gradient(0deg, #F56038, #F23E2B);
                border-radius: 4px;
                padding: 0 80px 0 80px;
                height: 270px;
                box-shadow: 1px 1px 30px rgba(51, 51, 51, 0.4);
                .left{
                    position: relative;
                    .bg{
                        width: 332px;
                        height: 169px;
                        display: block;
                    }
                    .code{
                        width: 112px;
                        height: 112px;
                        position: absolute;
                        right: 6px;
                        top: 20px;
                    }
                }
                .right{
                    margin-left: 160px;
                    .title{
                        color: #FFF600;
                        font-size: 16px;
                        font-weight: bold;
                    }
                }
                .textUl{
                    font-size: 14px;
                    color: #fff;
                    margin-top: 20px;
                    .item{
                        margin-bottom: 15px;
                        .span{
                            color: #FFF600;
                        }
                    }
                }
            }
            .blockCard2{
                width: 1190px;
                margin: 60px auto;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: linear-gradient(0deg, #F56038, #F23E2B);
                border-radius: 4px;
                padding: 0 80px 0 80px;
                height: 270px;
                box-shadow: 1px 1px 30px rgba(51, 51, 51, 0.4);
                .left{
                    position: relative;
                    
                    .bg{
                        width: 349px;
                        height: 222px;
                        display: block;
                    }
                }
                .right{
                    margin-right: 100px;
                    .title{
                        color: #FE8C00;
                        font-size: 16px;
                        font-weight: bold;
                    }
                }
                .textUl{
                    font-size: 14px;
                    color: #fff;
                    margin-top: 20px;
                    .item{
                        margin-bottom: 15px;
                    }
                }
            }
        }
    }
    .loginSpringFestival{
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 666;
        .loginForm{
            width: 480px;
            background: #ffffff;
            position: absolute;
            top: 50%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            left: 0;
            right: 0;
            margin: auto;
            border-radius: 6px;
            background: url(./images/tbg.png) no-repeat;
            background-size: 100% 100%;
            height: 552px;
            .titleClose{
                position: relative;
                height: 50px;
                .closeClass{
                    width:18px;
                    height:18px;
                    position:absolute;
                    right:20px;
                    top:20px;
                }
            }
            .logo{
                width: 187px;
                height: 30px;
                display: block;
                margin: auto;
            }
            .titleTip{
                width: 319px;
                height: 33px;
                display: block;
                margin: 30px auto 20px auto;
            }
            .htime{
                color: #FCFEEA;
                font-size: 12px;
                text-align: center;
            }
            .formData{
                margin: 30px;
                background: #fff;
                border-radius: 12px;
                padding: 50px 50px 0 50px;
                .loginInput{
                    margin-bottom: 0;
                    .msgTip{
                        font-size: 14px;
                        color: #F01C1D;
                        text-align: center;
                        margin: 10px 0;
                    }
                    .item{
                        position: relative;
                        line-height: 40px;
                        height: 40px;
                        font-size: 14px;
                        .lable{
                            display: flex;
                            align-items: center;
                            color: #666666;
                            font-size: 14px;
                            position: absolute;
                            z-index: 9;
                            left: 10px;
                            width: 100px;
                            .phone{
                                width: 18px;
                                height: 18px;
                                margin-right: 2px;
                            }
                        }
                        .input{
                            position:absolute;
                            left:0;
                            top: 0;
                            /deep/ .ivu-input{
                                position:absolute;
                                left:0;
                                top: 0;
                                z-index:3;
                                text-indent:76px;
                                height: 40px;
                                line-height: 40px;
                            }
                        }
                        
                        .loginVertial{
                            position: absolute;
                            width:85px;
                            background:rgba(240,240,240,1);
                            right:6px;
                            top:6px;
                            text-align:center;
                            font-size:12px;
                            font-weight:400;
                            color:rgba(51,51,51,1);
                            cursor:pointer;
                            border:none;
                            outline: none;
                            z-index: 10;
                            border-radius: 14px;
                            height: 28px;
                            line-height: 28px;
                        }
                        .loginlabel{
                            position: absolute;
                            left: 10px;
                            width: 56px;
                            font-size: 14px;
                            font-weight: 400;
                            color: #666666;
                            z-index: 5;
                            height: 38px;
                            line-height: 38px;
                            /deep/ .ivu-input{
                                position:absolute;
                                left:0;
                                z-index:3;
                                text-indent:76px;
                            }
                        }
                    }
                }
                .fuxy{
                    display:flex;
                    justify-content: flex-start;
                    align-items: center;
                    margin-top: 30px;
                    img{
                        margin-right:10px;
                    }
                    p{
                        height:20px;
                        font-size:14px;
                        font-weight:400;
                        color:rgba(153,153,153,1);
                        line-height:20px;
                    }
                    a{
                        height:20px;
                        font-size:14px;
                        font-weight:400;
                        color:#FF7A00;
                        line-height:20px;
                    }
                }
                .infoBtnPay{
                    font-size: 14px;
                    width: 250px;
                    background: #F01C1D;
                    margin: 20px auto 20px auto;
                    color: #fff;
                    text-align: center;
                    line-height: 40px;
                    border-radius: 4px;
                    cursor: pointer;
                    &:hover{
                        background: rgba(240, 28, 29, 0.7);
                    }
                }
            }
            
        }
    }
</style>